import React from 'react'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'
import WebBody from '../components/web/WebBody'

const WebsiteDevelopment = () => {
  return (
    <div>
        <Navbar></Navbar>
        <WebBody></WebBody>
        <Footer></Footer>
    </div>
  )
}

export default WebsiteDevelopment
